/**
 * Helper to format default value object into string
 *
 * @param {Object} defaultObj - Object containing value and unit properties
 * @param {number} defaultObj.value - The numeric value
 * @param {string} defaultObj.unit - The CSS unit (deg, %, rem, etc.)
 * @returns {string} Formatted CSS value string (e.g., "-45deg", "10rem")
 */
export function formatDefaultValue(defaultObj) {
  return `${defaultObj.value}${defaultObj.unit}`;
}

/**
 * Helper to set CSS variable with optional unit and default value
 *
 * @param {HTMLElement} root - The root element (usually document.documentElement)
 * @param {string} varName - The CSS custom property name (e.g., "--dropzone-width")
 * @param {number|undefined|null|string} value - The value to set (if falsy except 0, uses defaultValue)
 * @param {string} unit - The CSS unit to append to the value
 * @param {string} defaultValue - The fallback value to use if value is falsy (except 0)
 */
export function setCSSVarWithUnit(root, varName, value, unit, defaultValue) {
  if (value || value === 0) {
    root.style.setProperty(varName, `${value}${unit}`);
  } else {
    root.style.setProperty(varName, defaultValue);
  }
}
